.fileItem {
  display: flex;
  align-items: center;
  gap: var(--ant-padding-xs);
  padding: var(--ant-padding-xs) var(--ant-padding-sm);
  border-radius: var(--ant-border-radius);
  border: 1px solid var(--ant-color-border);
  background: var(--ant-color-bg-container);
  margin-bottom: var(--ant-margin-xs);
  transition: border-color 0.2s;
}

.fileItem:hover {
  border-color: var(--ant-color-primary);
}

.fileItemError {
  border-color: var(--ant-color-error);
  background: var(--ant-color-error-bg);
}

.fileName {
  flex: 1;
  min-width: 0;
}

.descriptionInput {
  width: 200px;
  flex-shrink: 0;
}
